import React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { SERVER_URL } from '../constants';
import { Stack } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import TextField from '@mui/material/TextField';
import { formatDateTime } from '../helpers/Helpers';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function EditOfficePost (props) {

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setContent(props.content === null ? "" : props.content);
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        setOpen(false);
    };

    const[content, setContent] = useState("");

    const handleChange = (event) => {
        setContent(event.target.value);
    }

    const handleSave = () => {
        if (props.postId)
        {
            updateContent()
        } else {
            createPost();
            props.scrollToTop();
        }
        handleClose();
    }

    const handleKeyPress = (e) => {
        if (e.keyCode === 13) {
            // e.preventDefault();
            // handleSave();
        }
    }

    const updateContent = () => {
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/update-office-post',
        {
            method: 'PUT',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify({
                "id" : props.postId,
                "office_id" : props.officeId,
                "content" : content
            })
        })
        .then(response => response.json())
        .then(data => {
            // console.log("data", data);
            if (data.status == 1) {
                props.fetchPosts();
            }
            else {
                
            }
        })
        .catch(err => console.error(err))
    }

    const createPost = () => {
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/create-office-post',
        {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify({
                "office_id" : props.officeId,
                "content" : content
            })
        })
        .then(response => response.json())
        .then(data => {
            // console.log("data", data);
            if (data.status == 1) {
                props.fetchPosts();
            }
            else {
                
            }
        })
        .catch(err => console.error(err))
    }

    return(
        <React.Fragment>
            <Button disabled={props.disabled} onClick={handleClickOpen}>
                {props.postId ? "Edit" : "New Advisory"}
            </Button>
            <BootstrapDialog
                sx={{
                    "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "500px",  // Set your width here
                    },
                    },
                }}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Advisory
                    {props.date ?
                    <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 13 }}>
                    {formatDateTime(props.date)}
                    </Typography>
                    : null }
                </DialogTitle>
                <DialogContent dividers={true} sx={{ m: 0, p: 0 }} >
                    {!props.id ?
                    <Typography gutterBottom sx={{ fontSize: 13 }}>
                        This advisory will be automatically sent to all clients with confirmed bookings.
                    </Typography>
                    : null }
                    <TextField
                        sx={{ width: 1 }}
                        name='content'
                        value={content}
                        id="outlined-multiline-static"
                        multiline
                        minRows={4}
                        maxRows={8}
                        inputProps={{ maxLength: 800 }}
                        onChange={handleChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyDown={handleKeyPress}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} >Cancel</Button>
                    <Button disabled={!content} onClick={handleSave} >Save</Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}

export default EditOfficePost;